import './Policy.scss';

const Policy = () => {
    return (
        <div className='policy-container'>
            <p>&copy; 2022</p>
        </div>
    )
}

export default Policy;